export function getOrderDraftState(code:string, orderdraftstate:OrderDraftState[]) {
    const item = orderdraftstate.find(i=>i.code===code)
    return item;
}